"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var react_1 = require("@heroui/react");
var constants_1 = require("../constants");
var utils_1 = require("@doshexchnage/utils");
var challenge_1 = require("../../../../../../reducers/slices/challenge/challenge");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var react_3 = require("@iconify/react");
var mdi_add_1 = require("../../../../../../components/icons/mdi:add");
var mdi_arrow_down_drop_1 = require("../../../../../../components/icons/mdi:arrow-down-drop");
var mdi_arrow_drop_up_1 = require("../../../../../../components/icons/mdi:arrow-drop-up");
var challengeEditorContext_1 = require("../../../../../../contexts/challengeEditorContext");
var CustomNode = function (props) {
    var _a, _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var id = props.id, type = props.type, 
    // category,
    data = props.data, draggable = props.draggable, children = props.children, configurationComponent = props.configurationComponent, colors = props.colors, infoPopOver = props.infoPopOver, iconProp = props.icon, selected = props.selected, sourceHandle = props.sourceHandle, targetHandle = props.targetHandle;
    var className = props.className;
    var _c = (0, react_2.useState)(constants_1.DefaultNodeIcon), icon = _c[0], setIcon = _c[1];
    var _d = (0, react_2.useState)(), config = _d[0], setConfig = _d[1];
    // const isGraphNode = Boolean(id);
    var nodeType = data.node_type;
    (0, react_2.useEffect)(function () {
        if (iconProp) {
            setIcon(iconProp);
        }
    }, [iconProp]);
    (0, react_2.useEffect)(function () {
        var _a, _b, _c;
        // if (isGraphNode) {
        var nodeConfig = (_a = constants_1.NodeConfigurations[nodeType]) === null || _a === void 0 ? void 0 : _a.find(function (nodeConfig) { return nodeConfig.type === type && nodeConfig.data.name === data.name; });
        if (nodeConfig) {
            if (!icon && ((_b = nodeConfig.data) === null || _b === void 0 ? void 0 : _b.icon)) {
                setIcon((_c = nodeConfig.data) === null || _c === void 0 ? void 0 : _c.icon);
            }
            setConfig(nodeConfig);
            // if (!data.schema && nodeConfig.data?.schema) {
            //   dispatch(setNode({ id, data: { ...data, schema: nodeConfig.data?.schema }, edit: false }));
            // }
        }
        // }
    }, [id, type, data]);
    var disallowedNodeTypes = React.useMemo(function () {
        var _a;
        return (_a = config === null || config === void 0 ? void 0 : config.data) === null || _a === void 0 ? void 0 : _a.disallow;
    }, [(_a = config === null || config === void 0 ? void 0 : config.data) === null || _a === void 0 ? void 0 : _a.disallow]);
    var allowedNodeTypes = React.useMemo(function () {
        var _a;
        return (_a = config === null || config === void 0 ? void 0 : config.data) === null || _a === void 0 ? void 0 : _a.allow;
    }, [(_b = config === null || config === void 0 ? void 0 : config.data) === null || _b === void 0 ? void 0 : _b.allow]);
    var _e = (0, react_2.useState)(true), showConfiguration = _e[0], setShowConfiguration = _e[1];
    var _f = (0, react_2.useState)(false), hasErrors = _f[0], setHasErrors = _f[1];
    (0, react_2.useEffect)(function () {
        // if (!isGraphNode) return;
        if (data.errors && Object.keys(data.errors).length > 0) {
            setHasErrors(true);
            setShowConfiguration(true);
        }
        else if (hasErrors) {
            setHasErrors(false);
        }
    }, [data.errors]);
    var borderColor = "border-borders";
    if (props.selected) {
        borderColor = "border-tertiary";
    }
    else if (hasErrors) {
        borderColor = "border-error";
    }
    var InfoPopOver = function () { return ((0, jsx_runtime_1.jsxs)(react_1.Tooltip, { children: [(0, jsx_runtime_1.jsx)(react_1.Tooltip.Trigger, { children: (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "secondary", children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:information-outline", width: 24 }) }) }), (0, jsx_runtime_1.jsx)(react_1.Tooltip.Content, { placement: "bottom", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col max-w-sm rounded-sm", children: [(0, jsx_runtime_1.jsx)("div", { className: "bold bg-accent-soft text-lg p-2 shadow", children: infoPopOver === null || infoPopOver === void 0 ? void 0 : infoPopOver.summary }), (0, jsx_runtime_1.jsx)("div", { className: "p-2", children: infoPopOver === null || infoPopOver === void 0 ? void 0 : infoPopOver.content })] }) })] })); };
    var RenderInfo = function () {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center w-full divide-primary-foreground/30 divide-x gap-2 ", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", onPress: function () { return setShowConfiguration(!showConfiguration); }, variant: "ghost", className: "text-primary-foreground", children: showConfiguration ? (0, jsx_runtime_1.jsx)(mdi_arrow_drop_up_1.MdiArrowDropUp, { fontSize: 16 }) : (0, jsx_runtime_1.jsx)(mdi_arrow_down_drop_1.MdiArrowDownDrop, { fontSize: 16 }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center gap-2 pl-2", children: [icon, (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 flex-col", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex flex-row", children: (0, jsx_runtime_1.jsx)("p", { className: "text-primary-foreground text-base", children: (_a = data === null || data === void 0 ? void 0 : data.name) !== null && _a !== void 0 ? _a : "Node" }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-row items-center justify-between", children: (0, jsx_runtime_1.jsx)("p", { className: "text-primary-foreground/70 text-[10px]", children: utils_1.Text.capitalizeWords(nodeType) }) })] })] })] }));
    };
    var RenderSourceHandle = function () {
        var edges = (0, react_redux_1.useSelector)(function (state) { return state.challengeState.edges; });
        // calculate edges only on change
        var hasTargetEdge = React.useMemo(function () {
            return edges.some(function (edge) { return edge.source === id; });
        }, [edges]);
        var nextNodeTypes = React.useMemo(function () {
            return Object.keys(constants_1.NodeCategoryLabels).filter(function (category) { return !["template", "objective"].includes(category); });
        }, []);
        if (hasTargetEdge || isReadOnly) {
            return null;
        }
        var MemoizedHandle = React.memo(function (_a) {
            var handle = _a.handle;
            return ((0, jsx_runtime_1.jsx)("div", { className: "flex rounded text-primary-foreground center items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "primary", className: "translate-y-[20px] rounded-full shadow-md", onPress: function () {
                        dispatch((0, challenge_1.setNodeModal)({
                            isOpen: true,
                            nodeId: props.id,
                            nodeType: props.type,
                            nodeTypes: nextNodeTypes,
                            disallowedNodeTypes: disallowedNodeTypes,
                            allowedNodeTypes: allowedNodeTypes,
                        }));
                    }, children: (0, jsx_runtime_1.jsx)(mdi_add_1.MdiAdd, { className: "center", fontSize: 24 }) }) }));
        });
        return (0, jsx_runtime_1.jsx)(MemoizedHandle, { handle: sourceHandle });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(react_1.Card, { className: "min-w-[250px] max-w-md gap-0 overflow-hidden border p-0 shadow-md ".concat(selected ? "border-primary" : "border-transparent hover:border-primary/50"), children: [(0, jsx_runtime_1.jsx)(react_1.Card.Header, { className: "bg-primary p-3 text-primary-foreground", children: (0, jsx_runtime_1.jsx)(RenderInfo, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "transition-all duration-300  ".concat(showConfiguration ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0", " "), children: (0, jsx_runtime_1.jsx)(react_1.Card.Content, { className: "p-4", children: configurationComponent(data) }) })] }), sourceHandle, targetHandle] }), RenderSourceHandle()] }));
};
exports.default = (0, react_2.memo)(CustomNode);
